import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const UpdateStarredBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStarredBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardStarId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBoardStar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"boardStarId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardStarId"}}},{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pos"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"UpdateStarredBoard","document":UpdateStarredBoardDocument}} as const;
export type UpdateStarredBoardMutationVariables = Types.Exact<{
  boardStarId: Types.Scalars['ID']['input'];
  memberId: Types.Scalars['ID']['input'];
  pos: Types.Scalars['Int']['input'];
}>;


export type UpdateStarredBoardMutation = (
  { __typename: 'Mutation' }
  & { updateBoardStar?: Types.Maybe<(
    { __typename: 'BoardStar' }
    & Pick<Types.BoardStar, 'id'>
  )> }
);

export type UpdateStarredBoardMutationFn = Apollo.MutationFunction<
  UpdateStarredBoardMutation,
  UpdateStarredBoardMutationVariables
>;

/**
 * __useUpdateStarredBoardMutation__
 *
 * To run a mutation, you first call `useUpdateStarredBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStarredBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStarredBoardMutation, { data, loading, error }] = useUpdateStarredBoardMutation({
 *   variables: {
 *      boardStarId: // value for 'boardStarId'
 *      memberId: // value for 'memberId'
 *      pos: // value for 'pos'
 *   },
 * });
 */
export function useUpdateStarredBoardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateStarredBoardMutation,
    UpdateStarredBoardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateStarredBoardMutation,
    UpdateStarredBoardMutationVariables
  >(UpdateStarredBoardDocument, options);
}
export type UpdateStarredBoardMutationHookResult = ReturnType<
  typeof useUpdateStarredBoardMutation
>;
export type UpdateStarredBoardMutationResult =
  Apollo.MutationResult<UpdateStarredBoardMutation>;
export type UpdateStarredBoardMutationOptions = Apollo.BaseMutationOptions<
  UpdateStarredBoardMutation,
  UpdateStarredBoardMutationVariables
>;
